import { useState, useEffect } from "react";
import { Button, Grid2 as Grid } from "@mui/material";
import { useNavigate, useLocation } from "react-router";
import { injectIntl } from "react-intl";
import {
  PATH_PRIVACY_POLICY,
  PATH_COOKIE_POLICY,
  PATH_DICHIARAZIONE_ACCESSIBILITA,
  PATH_COLORI_TRIAGE,
  PATH_FAQ,
  PATH_REGIONE,
  PATH_SAN_MARTINO,
  PATH_ALISA,
  PATH_LD,
  PATH_HOME,
  PATH_INFO,
  PATH_CONTATTI,
} from "../../path";
import { LogoAlisaIcon, LogoLDIcon, LogoRegioneIcon } from "../../styles/images";
import {
  FOOTER_PRIVACY_POLICY,
  FOOTER_COOKIE_POLICY,
  FOOTER_ACCESSIBILITA,
  FOOTER_COLORI_TRIAGE,
  FOOTER_FAQ,
  FOOTER_CONTATTI,
} from "../../modules/language";
import { getMessageString } from "../../utility";
import { Icona } from "./";
import { useSelector } from "react-redux";
import { getMonitoraggio, ID_OSPEDALE, ottieniLogoPs } from "../../modules/tracking";

export const Footer = injectIntl(({ intl }) => {
  const monitoraggio = useSelector(getMonitoraggio);
  const navigate = useNavigate();
  const location = useLocation();
  const [mobileMode, setMobileMode] = useState(window.innerWidth < 1200 ? true : false);

  const path = location.pathname;

  useEffect(() => {
    const handleResize = () => setMobileMode(window.innerWidth < 1200 ? true : false);
    window.addEventListener("resize", handleResize);
    // Clean up the event listener when the component unmounts
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    (!mobileMode || (mobileMode && [PATH_HOME, PATH_INFO].includes(path))) && (
      <Grid container spacing={{ xs: 2, lg: 0 }} className="footer">
        <Grid container size={{ xs: 12, lg: 5 }} className="loghi">
          <Grid size={monitoraggio ? 3 : 4}>
            <Button onClick={() => window.open(PATH_REGIONE, "_blank")} aria-label="Regione Liguria">
              <LogoRegioneIcon />
            </Button>
          </Grid>
          {monitoraggio && (
            <Grid size={3}>
              <Button onClick={() => window.open(PATH_SAN_MARTINO, "_blank")} aria-label="San Martino">
                {ottieniLogoPs(monitoraggio[ID_OSPEDALE])}
              </Button>
            </Grid>
          )}
          <Grid size={monitoraggio ? 3 : 4}>
            <Button onClick={() => window.open(PATH_ALISA, "_blank")} aria-label="Alisa">
              <LogoAlisaIcon />
            </Button>
          </Grid>
          <Grid size={monitoraggio ? 3 : 4}>
            <Button onClick={() => window.open(PATH_LD, "_blank")} aria-label="Liguria Digitale">
              <LogoLDIcon />
            </Button>
          </Grid>
        </Grid>
        <Grid container spacing={2} size={{ xs: 12, lg: 7 }} className="links">
          <Grid size={4}>
            <Button startIcon={<Icona tipologia="privacy" />} onClick={() => navigate(PATH_PRIVACY_POLICY)}>
              {getMessageString(intl, FOOTER_PRIVACY_POLICY)}
            </Button>
          </Grid>
          <Grid size={3}>
            <Button startIcon={<Icona tipologia="cookies" />} onClick={() => navigate(PATH_COOKIE_POLICY)}>
              {getMessageString(intl, FOOTER_COOKIE_POLICY)}
            </Button>
          </Grid>
          <Grid size={5}>
            <Button startIcon={<Icona tipologia="accessibilita" />} onClick={() => window.open(PATH_DICHIARAZIONE_ACCESSIBILITA, "_blank")}>
              {getMessageString(intl, FOOTER_ACCESSIBILITA)}
            </Button>
          </Grid>
          <Grid size={4}>
            <Button startIcon={<Icona tipologia="lista" />} onClick={() => navigate(PATH_COLORI_TRIAGE)}>
              {getMessageString(intl, FOOTER_COLORI_TRIAGE)}
            </Button>
          </Grid>
          <Grid size={3}>
            <Button startIcon={<Icona tipologia="faq" />} onClick={() => navigate(PATH_FAQ)}>
              {getMessageString(intl, FOOTER_FAQ)}
            </Button>
          </Grid>
          <Grid size={5}>
            <Button startIcon={<Icona tipologia="email" />} onClick={() => navigate(PATH_CONTATTI)}>
              {getMessageString(intl, FOOTER_CONTATTI)}
            </Button>
          </Grid>
        </Grid>
      </Grid>
    )
  );
});
